import React from "react";

import ContentLoader from 'react-content-loader';

function LoadingContent() {
  let width = 100;

  return (<>
    <ContentLoader
      speed={3}
      width="100%"
      height={400}
      viewBox="0 0 400 220"
      backgroundColor="#323F4B"
      foregroundColor="#1F2933"
    >
      <rect x="85" y="16" rx="2" ry="2" width="62" height="42" />
      <rect x="168" y="16" rx="2" ry="2" width="62" height="42" />
      <rect x="250" y="16" rx="2" ry="2" width="62" height="42" />
      <rect x="332" y="16" rx="2" ry="2" width="62" height="42" />
      <rect x="4" y="16" rx="2" ry="2" width="62" height="42" />
      <rect x="86" y="69" rx="2" ry="2" width="62" height="42" />
      <rect x="169" y="69" rx="2" ry="2" width="62" height="42" />
      <rect x="251" y="69" rx="2" ry="2" width="62" height="42" />
      <rect x="333" y="69" rx="2" ry="2" width="62" height="42" />
      <rect x="5" y="69" rx="2" ry="2" width="62" height="42" />
      <rect x="86" y="122" rx="2" ry="2" width="62" height="42" />
      <rect x="169" y="122" rx="2" ry="2" width="62" height="42" />
      <rect x="251" y="122" rx="2" ry="2" width="62" height="42" />
      <rect x="333" y="122" rx="2" ry="2" width="62" height="42" />
      <rect x="5" y="122" rx="2" ry="2" width="62" height="42" />
      <rect x="86" y="175" rx="2" ry="2" width="62" height="42" />
      <rect x="169" y="175" rx="2" ry="2" width="62" height="42" />
      <rect x="251" y="175" rx="2" ry="2" width="62" height="42" />
      <rect x="333" y="175" rx="2" ry="2" width="62" height="42" />
      <rect x="5" y="175" rx="2" ry="2" width="62" height="42" />
    </ContentLoader>
  </>);
}

export default LoadingContent;